import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { RoleManagement } from '../modal';

export default function reducer(state: RoleManagement = new RoleManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.ROLES_MGMT_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.ROLES_MGMT_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.ROLES_MGMT_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
